export enum MfaErrorType {
  MfaRequired = "mfa_required",
  MfaCodeError = "mfa_code_error",
  MfaTokenError = "mfa_token_error",
  MfaError = "mfa_error",
  // RYNO-14957: the throttle responses, mirrored from MfaResponseCodes on the identity provider.
  TooManyAttempts = "too_many_attempts",
  AccountLocked = "account_locked",
  TooManyRequests = "too_many_requests",
}
